<template>
  <v-list-item>
    <v-list-item-content>
      <v-container class="pa-0">
        <v-row no-gutters v-for="(items, i) in field" :key="i">
          <template v-for="(item, j) in items">
            <v-col class="pt-0 pb-5" :key="`${i}_${j}`">
              <v-list-item-subtitle class="grey--text">
                {{ item && item.label }}
              </v-list-item-subtitle>
              <v-list-item-title class="black--text">
                <span
                  v-if="['status', 'layanan'].indexOf(item.key) === -1"
                  v-html="$getDeepObj(detail, `${item.key}`) || ''"
                />
                <template v-else-if="item.key === 'status'">
                  <chips
                    :chip="{
                      label: $getDeepObj(detail, `${item.key}`)['text'],
                      icon: $getDeepObj(detail, `${item.key}`)['icon'],
                    }"
                    :colorIdx="Number($getDeepObj(detail, `${item.key}`)['value'])"
                  ></chips>
                </template>
                <template v-else-if="item.key === 'layanan'">
                  <v-chip
                    class="mt-1"
                    small
                    color="info"
                    outlined
                    v-for="(item, i) in $getDeepObj(detail, `${item.key}`)"
                    :key="i"
                  >
                    {{ item.aplikasi && item.aplikasi.nama }}
                  </v-chip>
                </template>
              </v-list-item-title>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'DetailList',
  props: {
    detail: {
      type: Object,
      required: true,
    },
    field: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped></style>
